import { Injectable } from '@angular/core';
import { SupervisorFunction } from '@shared/index';
import { SupervisorService } from '../supervisor.service';

@Injectable({
  providedIn: 'root'
})
export class SupervisorThreadBroadcastService {

  public selectedThreadsSet: Set<string> = new Set<string>();

  constructor(private supervisorService: SupervisorService) { }

  public broadcastSupervisorPrompt(prompt: string): boolean {
    for (const thread of this.selectedThreadsSet.keys()) {
      void this.supervisorService.sendAdminMessageToThread(prompt, thread);
    }
    return true;
  }

  public broadcastSupervisorFunction(func: SupervisorFunction): void {
    for (const thread of this.selectedThreadsSet.keys()) {
      void this.supervisorService.triggerSupervisorfunctionToThread(func, thread);
    }
  }

  public toggleBroadcastForThread(threadId: string): void {
    if (this.selectedThreadsSet.has(threadId)) {
      this.selectedThreadsSet.delete(threadId);
    } else {
      this.selectedThreadsSet.add(threadId);
    }
  }

  public noSelectedThreadActive(): boolean {
    return !Array.from(this.selectedThreadsSet.values()).some(t => this.supervisorService.isThreadActive(t));
  }

  public inactiveThreadCount(): number {
    return Array.from(this.selectedThreadsSet.values()).filter(t => !this.supervisorService.isThreadActive(t)).length;
  }

  public toggleAllThreadsForBroadcast() {
    if (this.allThreadSelected()) {
      this.selectedThreadsSet.clear();
    } else {
      this.selectedThreadsSet = new Set(this.supervisorService.filteredThreads.map(t => t.threadId));
    }
  }

  public allThreadSelected(): boolean {
    return this.supervisorService.filteredThreads.every(t => this.selectedThreadsSet.has(t.threadId));
  }
}
